import { content } from './lib/content'
import { LoanApplicationForm } from './components/loan-application-form'

function App() {
  return (
    <div className='min-h-screen bg-gray-50'>
      <header className='border-b border-gray-200 bg-[#102f49] py-6'>
        <div className='mx-auto flex max-w-2xl items-center gap-4 px-4'>
          <img src='/diamonds.svg' alt='Triple E RV' className='h-12 w-12' />
          <h1 className='text-3xl font-semibold text-white'>{content.title}</h1>
        </div>
      </header>
      <main className='mx-auto max-w-2xl px-4 py-8'>
        <div className='mb-6 space-y-3 text-gray-700'>
          {content.intro.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>

        <h3 className='mb-3 text-lg font-semibold text-gray-900'>Loan Details</h3>
        <ul className='mb-6 list-disc space-y-2 pl-5 text-gray-700'>
          {content.loanDetails.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
        <p className='mb-8 font-medium text-gray-800'>{content.agreementNote}</p>

        <LoanApplicationForm />
      </main>
    </div>
  )
}

export default App
